module.exports = __webpack_public_path__ + "static/logo-dff535a85c314600d3bd9f545c4cfc52.png";